<script lang="ts">
	import { page } from '$app/state';
	import type { Snippet } from 'svelte';

	interface Props {
		children: Snippet;
		minimumRole?: 'user' | 'operator' | 'admin';
	}
	let { children, minimumRole = 'admin' }: Props = $props();

	// Role hierarchy: user < operator < admin
	const roleHierarchy = {
		user: 0,
		operator: 1,
		admin: 2
	} as const;

	const shouldRender = $derived(() => {
		const userRole = page.data.loggedInUser?.role;
		if (!userRole) return false;

		const userLevel = roleHierarchy[userRole] ?? -1;
		const requiredLevel = roleHierarchy[minimumRole] ?? 2;

		return userLevel >= requiredLevel;
	});
</script>

{#if shouldRender()}{@render children?.()}{/if}
